module.exports = __webpack_public_path__ + "static/media/swingHardware3.48333cb6.png";